import {PipelineGraphEntity} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BasePipelineGraphView, BasePipelineGraphViewProps} from "../BasePipelineGraphView/BasePipelineGraphView";
import {
  toGraphViewEdges,
  toGraphViewNodes,
  toPipelineGraphViewEdges,
  toPipelineGraphViewNodes
} from "../BasePipelineGraphView/config";

export type PipelineGraphViewProps =
  Omit<BasePipelineGraphViewProps, 'layoutEngineType' | 'readOnly' | 'nodes' | 'edges'>
  & {
  pipelineGraph: PipelineGraphEntity
}

export const PipelineGraphView = (props: PipelineGraphViewProps) => {
  const {pipelineGraph, ...rest} = props

  const nodes = useMemo(() => {
    return toGraphViewNodes(
      toPipelineGraphViewNodes(pipelineGraph.nodes)
    );
  }, [pipelineGraph]);

  const edges = useMemo(() => {
    return toGraphViewEdges(
      toPipelineGraphViewEdges(pipelineGraph.edges)
    );
  }, [pipelineGraph]);

  return (
    <BasePipelineGraphView
      {...rest}
      layoutEngineType="VerticalTree"
      readOnly={true}
      nodes={nodes}
      edges={edges}
    />
  );
};
